"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getResponsiveMaxWidth = void 0;

var _stylingConstants = require("./stylingConstants");

/**
 * Get the max pixel width which corresponds to an Office UI Fabric
 * `ResponsiveMode` value.
 */
var getResponsiveMaxWidth = function getResponsiveMaxWidth(mode) {
  var i = Math.max(0, Math.min(_stylingConstants.RESPONSIVE_MAX_CONSTRAINT.length - 1, mode));
  return _stylingConstants.RESPONSIVE_MAX_CONSTRAINT[i];
};

exports.getResponsiveMaxWidth = getResponsiveMaxWidth;